import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import _get from 'lodash/get';

export default [
  <Route
    exact
    path="/business/products/:productType"
    render={props => (
      <AsyncPage key={_get(props, 'match.params.productType', '')} {...props} />
    )}
  />,
];
